export default (childSelector, btnText = 'Load More') => ({
    url: null,
    page: 1,
    grid: null,
    loading: false,
    gridSelector: '[data-load-more-grid]',
    loadMoreText: btnText,

    init() {
        this.url = window.location.href
        this.page = new URLSearchParams(window.location.search).get('page') || 1
        this.grid = document.querySelector(this.gridSelector)
    },
    async loadMore() {
        if (!this.grid || !childSelector) {
            throw new Error('Grid and child selector are required.')
        }

        this.loading = true
        this.loadMoreText = 'Loading…'
        this.$el.setAttribute('disabled', true)

        this.page++
        const loadMoreUrl = new URL(this.url)
        loadMoreUrl.searchParams.set('page', this.page)
        history.replaceState({}, '', loadMoreUrl)

        const response = await fetch(loadMoreUrl)

        if (!response.ok) {
            this.loading = false
            this.loadMoreText = btnText
            this.$el.removeAttribute('disabled')
            throw new Error('Failed to fetch items.')
        }

        const html = await response.text()

        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        const selector = `${this.gridSelector} ${childSelector}`
        const newItems = Array.from(doc.querySelectorAll(selector))

        this.grid.append(...newItems)

        this.loading = false
        this.loadMoreText = btnText
        this.$el.removeAttribute('disabled')
    },
})
